class AfsQuantitySelector extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.input = this.querySelector('[data-afs-quantity]');
    if (!this.input) return;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-afs-quantity-step]');
      if (!button || button.disabled) return;
      event.preventDefault();
      const direction = Number(button.dataset.afsQuantityStep || 0);
      this.setQuantity(this.value() + direction, true);
    });
    this.input.addEventListener('input', () => this.syncButtons());
    this.input.addEventListener('change', () => this.setQuantity(this.value(), false));
    this.syncButtons();
  }

  bounds() {
    const min = Math.max(1, Math.floor(Number(this.input?.min) || 1));
    const parsedMax = Math.floor(Number(this.input?.max));
    return { min, max: Number.isFinite(parsedMax) && parsedMax >= min ? parsedMax : Infinity };
  }

  value() {
    const { min, max } = this.bounds();
    const parsed = Math.floor(Number(this.input?.value));
    return Math.min(max, Math.max(min, Number.isFinite(parsed) ? parsed : min));
  }

  setQuantity(value, notify) {
    if (!this.input) return;
    const { min, max } = this.bounds();
    const next = Math.min(max, Math.max(min, Math.floor(Number(value) || min)));
    this.input.value = String(next);
    this.syncButtons();
    if (notify) {
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
      this.input.focus({ preventScroll: true });
    }
  }

  syncButtons() {
    if (!this.input) return;
    const { min, max } = this.bounds();
    const current = this.value();
    const decrease = this.querySelector('[data-afs-quantity-step="-1"]');
    const increase = this.querySelector('[data-afs-quantity-step="1"]');
    if (decrease) decrease.disabled = current <= min;
    if (increase) increase.disabled = current >= max;
  }
}

if (!customElements.get('afs-quantity-selector')) {
  customElements.define('afs-quantity-selector', AfsQuantitySelector);
}
